import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import HeaderWrapper from '../HeaderWrapper';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';

const HeaderWrapperStyled = styled(HeaderWrapper)`
  background: #eee;
  border: 1px solid #ccc;
`

const ChipStyled = styled(Chip)`
  margin-right: 4px;
  background: black;
  color: white;
`

const SelectStyled = styled(Select)`

`

class ChipSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedArray: [],
    };
  }

  handleChange = event => {
    const { onChange } = this.props;
    onChange(event.target.value);
    // this.setState({ selectedArray: event.target.value });
  };

  render() {
    const { options, multiple, onChange, onBlur, value, ...other } = this.props;
    return (
      <HeaderWrapperStyled {...other}>
        <SelectStyled
          multiple={multiple}
          value={value}
          input={<Input disableUnderline/>}
          onChange={this.handleChange}
          onBlur={onBlur}
          fullWidth
          renderValue={array => {
            return multiple ? (
              <div>
                {array.map((item, index) => (
                  <ChipStyled key={`chip-select-${index}`} label={item} />
                ))}
              </div>
            ) : (
              <ChipStyled key={array} label={array} />
            )
          }}
        >
          {options.map((item, index) => (
            <MenuItem key={`chip-menu-item-${index}`} value={item}>
              {item.name ? item.name : item}
            </MenuItem>
          ))}
        </SelectStyled>
      </HeaderWrapperStyled>
    )
  }
}

ChipSelect.propTypes = {
  value: PropTypes.array,
  options: PropTypes.array.isRequired,
};

ChipSelect.defaultProps = {
  multiple: true,
};

export default ChipSelect;
